document.addEventListener("DOMContentLoaded", () => {
  const inp = document.getElementById("SchoolSearchInput");
  if (!inp) return;

  const drawer = document.getElementById("NewSearchDrawer");
  const closeBtn = document.getElementById("NewSearchClose");
  const searchBtn = document.querySelector(".search-input--btn-new");

  const SCHOOLS = Array.isArray(window.SCHOOL_INDEX) ? window.SCHOOL_INDEX : [];
  const COLLECTIONS = Array.isArray(window.ALL_COLLECTIONS) ? window.ALL_COLLECTIONS : [];

  const norm = (s) => (s || "").toString().trim().toLowerCase();

  const cleanKeywords = (arr) => {
    return (Array.isArray(arr) ? arr : [])
      .map((k) => (k || "").toString().replace(/\r/g, "").trim())
      .filter(Boolean);
  };

  const getUniqueByUrl = (items) => {
    const seen = new Set();
    const out = [];

    (Array.isArray(items) ? items : []).forEach((item) => {
      if (!item || !item.url || seen.has(item.url)) return;
      seen.add(item.url);
      out.push(item);
    });

    return out;
  };

  const closeAllLists = (exceptEl) => {
    const lists = document.getElementsByClassName("autocomplete-items");
    for (let i = lists.length - 1; i >= 0; i--) {
      if (exceptEl !== lists[i] && exceptEl !== inp) {
        lists[i].parentNode.removeChild(lists[i]);
      }
    }
  };

  const highlightText = (title, val) => {
    const titleStr = String(title || "");
    const queryStr = String(val || "");
    const index = titleStr.toLowerCase().indexOf(queryStr.toLowerCase());

    if (index === -1 || !queryStr) return titleStr;

    return (
      titleStr.substring(0, index) +
      "<strong>" +
      titleStr.substring(index, index + queryStr.length) +
      "</strong>" +
      titleStr.substring(index + queryStr.length)
    );
  };

  const getSchoolMatches = (query) => {
    const q = norm(query);
    if (!q) return [];

    const results = [];

    SCHOOLS.forEach((school) => {
      const schoolName = norm(school.name);
      const keywords = cleanKeywords(school.keywords);
      const schoolCollections = getUniqueByUrl(school.collections);

      const schoolNameMatch = schoolName.includes(q);
      const keywordMatch = keywords.some((kw) => norm(kw).includes(q));
      const collectionTitleMatches = schoolCollections.filter((c) => norm(c.title).includes(q));

      if (schoolNameMatch || keywordMatch || collectionTitleMatches.length) {
        const collectionsToShow = collectionTitleMatches.length
          ? collectionTitleMatches
          : schoolCollections;

        results.push({
          schoolName: school.name,
          items: collectionsToShow
        });
      }
    });

    return results;
  };

  const getCollectionMatches = (query) => {
    const q = norm(query);
    if (!q) return [];

    const matched = [];

    COLLECTIONS.forEach((item) => {
      if (!item || !item.title) return;
      if (!norm(item.title).includes(q)) return;

      matched.push({
        title: item.title,
        url: item.url || `/collections/${item.handle}`
      });
    });

    return getUniqueByUrl(matched);
  };

  const renderAutocomplete = (query) => {
    closeAllLists();
    if (!query) return;

    const list = document.createElement("div");
    list.className = "autocomplete-items";
    inp.parentNode.appendChild(list);

    const schoolMatches = getSchoolMatches(query);

    // If school results exist, show only school-style grouped results
    if (schoolMatches.length) {
      schoolMatches.forEach((groupData) => {
        const group = document.createElement("div");
        group.className = "school-group";

        const label = document.createElement("div");
        label.className = "school-label";
        label.innerHTML = `Showing results for: <strong>${groupData.schoolName}</strong>`;
        group.appendChild(label);

        groupData.items.forEach((item) => {
          const row = document.createElement("div");
          row.className = "collection-item";
          row.innerHTML = highlightText(item.title, query);

          row.addEventListener("click", () => {
            window.location.href = item.url;
          });

          group.appendChild(row);
        });

        list.appendChild(group);
      });

      return;
    }

    // Otherwise normal collection results
    const collectionMatches = getCollectionMatches(query);

    if (collectionMatches.length) {
      collectionMatches.forEach((item) => {
        const row = document.createElement("div");
        row.className = "collection-item";
        row.innerHTML = highlightText(item.title, query);

        row.addEventListener("click", () => {
          window.location.href = item.url;
        });

        list.appendChild(row);
      });

      return;
    }

    const empty = document.createElement("div");
    empty.className = "is-empty";
    empty.innerHTML = `No matching results for: <strong>${query}</strong>`;
    list.appendChild(empty);
  };

  let currentFocus = -1;

  inp.addEventListener("input", function () {
    currentFocus = -1;
    renderAutocomplete(this.value.trim());
  });

  inp.addEventListener("keydown", function (e) {
    let x = document.getElementById(this.id + "autocomplete-list");
    if (!x) x = inp.parentNode.querySelector(".autocomplete-items");
    if (x) x = x.querySelectorAll(".collection-item");

    if (e.keyCode == 40) {
      currentFocus++;
      if (!x || !x.length) return;
      x.forEach((el) => el.classList.remove("autocomplete-active"));
      if (currentFocus >= x.length) currentFocus = 0;
      x[currentFocus].classList.add("autocomplete-active");
    } else if (e.keyCode == 38) {
      currentFocus--;
      if (!x || !x.length) return;
      x.forEach((el) => el.classList.remove("autocomplete-active"));
      if (currentFocus < 0) currentFocus = x.length - 1;
      x[currentFocus].classList.add("autocomplete-active");
    } else if (e.keyCode == 13) {
      e.preventDefault();

      // If user selected from dropdown with arrow keys
      if (currentFocus > -1 && x && x[currentFocus]) {
        x[currentFocus].click();
        return;
      }

      const q = inp.value.trim();
      if (!q) return;

      const schoolMatches = getSchoolMatches(q);

      // School query => go to school results page
      if (schoolMatches.length) {
        window.location.href = `/pages/school-collections-search?q=${encodeURIComponent(q)}`;
        return;
      }

      const collectionMatches = getCollectionMatches(q);

      // Normal collection query => go to first matching collection directly
      if (collectionMatches.length) {
        window.location.href = collectionMatches[0].url;
        return;
      }
    }
  });

    if (searchBtn) {
      searchBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const q = inp.value.trim();
        if (!q) return;

        const schoolMatches = getSchoolMatches(q);
        if (schoolMatches.length) {
          window.location.href = `/pages/school-collections-search?q=${encodeURIComponent(q)}`;
          return;
        }

        const collectionMatches = getCollectionMatches(q);
        if (collectionMatches.length) {
          window.location.href = collectionMatches[0].url;
        }
      });
    }

  document.addEventListener("click", function (e) {
    closeAllLists(e.target);
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      drawer?.classList.remove("open-search-drawer");
      document.body.classList.remove("js-drawer-open-right");
      closeAllLists();
    });
  }
});